import { render } from "./Stamp.vue?vue&type=template&id=4b0b858e&scoped=true"
import script from "./Stamp.vue?vue&type=script&lang=js"
export * from "./Stamp.vue?vue&type=script&lang=js"

import "./Stamp.vue?vue&type=style&index=0&id=4b0b858e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0b858e"]])

export default __exports__